import React, {Component} from 'react';
import PropTypes from "prop-types";
import _ from "lodash";

export default class Message extends Component {

	static propTypes = {
		messages: PropTypes.array,
		remove: PropTypes.func.isRequired,
		clear: PropTypes.func.isRequired
	};

	render() {
		const messages = _.map(this.props.messages, (message, key) => (
			<div className={'alert alert-dismissible fade show ' + (message.getAlertClass())} key={key}>
				<span>
					{message.code ? (
						<b>{message.code}: </b>
					) : null}
					{message.message}
				</span>
			</div>
		));

		return (
			<div className="message-panel">
				{messages}

				{this.props.messages.length ? (
					<button className="btn btn-primary clear-all" onClick={() => this.props.clear()}>Clear all</button>
				) : null}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/main/Message.js